import React from "react";
import "./Analytics.css";

const SimpleBarChart = ({ data }) => {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data.map((d) => d.value), 1);
  const maxPx = 140; // bar height cap in px within chart

  return (
    <div className="chart">
      {data.map((d) => {
        const h = Math.round((d.value / max) * maxPx);
        const heightPx = Math.max(d.value > 0 ? 2 : 0, h);
        return (
          <div key={d.label} className="chart-item">
            <div className="chart-bar" style={{ height: `${heightPx}px` }}></div>
            <div className="chart-label">{d.label}</div>
            <div className="chart-value">{d.value}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SimpleBarChart;
